module.exports = __webpack_public_path__ + "img/banner-bg-img.9da3aa4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/product/banner-bg-img.png
// module id = aJDR
// module chunks = 1